/** As histórias de EST, COM, CST, REC, CAD, BIB, ACS e PLT (p.57 a p.60). A lista inteira e a ordem estão em `../catalogo.ts`. */
import type { Historia } from '../catalogo';

const REVISAO = '05/10/2026';

export const HISTORIAS: readonly Historia[] = [
  /* ------------------------------------------------------------ EST · Estoque (p.57) */
  {
    codigo: 'COL-EST-01', titulo: 'Saldo', papel: 'almoxarifado',
    quero: 'ver quanto do item existe de fato em cada depósito', para: 'saber se a peça está na prateleira antes de prometê-la',
    significa: 'Quantidade física no depósito, depois da última contagem e dos movimentos.',
    calcula: 'Soma do livro do estoque por item e depósito: entradas, devoluções e ajustes de entrada menos saídas e ajustes de saída. Diesel e ARLA vêm do livro do tanque.',
    origem: 'Estoque · movimentos (view estoq.saldo, 0020). Muda a cada movimento lançado.',
    criterios: [
      'Uma saída lançada baixa o saldo na hora.',
      'Na mesa a coluna se chama Físico; no app, Saldo. Os dois mostram o mesmo número.',
      'Depois de uma contagem, o saldo é o contado.',
    ],
    situacao: 'rascunho', responsavel: 'Almoxarifado', revisadaEm: REVISAO,
  },
  {
    codigo: 'COL-EST-02', titulo: 'Reservado', papel: 'almoxarifado',
    quero: 'ver o que já está prometido', para: 'não entregar a peça de outra O.S.',
    significa: 'Separado para O.S. abertas: ainda está no estoque, mas não está livre.',
    calcula: 'Soma das reservas ativas do item, por depósito. A peça prevista na O.S. vira reserva por gatilho; aplicada, vira saída e consome a reserva.',
    origem: 'Estoque · reservas (estoq.reserva, 0020), criadas pela peça prevista na O.S.',
    criterios: [
      'Encerrar ou cancelar a O.S. solta a reserva que sobrou.',
      'Livre = saldo − reservado.',
      'Uma saída sem reserva que comeria a peça de outra O.S. é recusada, dizendo o disponível.',
    ],
    situacao: 'em_revisao', responsavel: 'Almoxarifado', revisadaEm: REVISAO,
  },
  {
    codigo: 'BTN-EST-03', titulo: 'Registrar contagem', papel: 'almoxarifado',
    quero: 'lançar o que contei na prateleira', para: 'o saldo do sistema bater com o físico sem apagar o histórico',
    significa: 'Lança a contagem física e acerta o saldo, guardando a diferença na trilha.',
    calcula: 'Trava a posição, lê o saldo e compara com o contado. Diferença zero não grava nada; diferente, grava um ajuste de entrada ou de saída com "contado X, sistema Y" no motivo. Exige a permissão estoque.ajustar.',
    origem: 'Estoque · POST /estoque/contagens, que grava em estoq.movimento.',
    criterios: [
      'Contado igual ao saldo: o toast diz que nada foi ajustado.',
      'Contado diferente: o movimento de ajuste aparece na lista, com as duas contas no motivo.',
      'Contagem negativa é recusada.',
      'No app o botão se chama Contagem e a folha termina em Registrar contagem.',
    ],
    situacao: 'rascunho', responsavel: 'Almoxarifado', revisadaEm: REVISAO,
  },
  {
    codigo: 'NUM-EST-04', titulo: 'Livre', papel: 'almoxarifado',
    quero: 'ver quanto do item posso entregar agora', para: 'não tirar da prateleira a peça reservada para outra O.S.',
    significa: 'O que está no depósito e não está reservado: é o que pode sair sem O.S. que o reserve.',
    calcula: 'Saldo − reservado, por item e depósito. Abaixo do estoque mínimo, o número sai em vermelho.',
    origem: 'Estoque · view estoq.saldo (coluna disponivel, 0020). Muda a cada movimento e a cada reserva.',
    criterios: [
      'Livre = saldo − reservado na mesma tela.',
      'Na mesa a coluna se chama Disponível.',
      'A folha de saída mostra o livre e recusa sair mais do que ele.',
    ],
    situacao: 'rascunho', responsavel: 'Almoxarifado', revisadaEm: REVISAO,
  },

  /* ------------------------------------------------------------ COM · Compras (p.57) */
  {
    codigo: 'IND-COM-01', titulo: 'Itens a comprar', papel: 'compras',
    quero: 'ver quantos itens ainda precisam de pedido', para: 'saber o tamanho da compra antes de cotar',
    significa: 'Falta que nenhum pedido aberto cobre ainda.',
    calcula: 'Conta os itens da necessidade líquida com Comprar maior que zero.',
    origem: 'Compras · view compras.necessidade_liquida (0052). Recalcula a cada abertura.',
    criterios: [
      'O número é a quantidade de linhas com Comprar maior que zero na lista.',
      'Aprovar o pedido que cobre o item tira o item da contagem.',
    ],
    situacao: 'rascunho', responsavel: 'Compras', revisadaEm: REVISAO,
  },
  {
    codigo: 'IND-COM-02', titulo: 'Críticos a comprar', papel: 'compras',
    quero: 'ver quantos itens críticos estão em falta', para: 'comprar primeiro o que para a máquina',
    significa: 'Item marcado como crítico, dos que faltam.',
    calcula: 'Dos itens a comprar, conta os que têm a marca de crítico no cadastro do item.',
    origem: 'Compras · necessidade líquida; Estoque · cadastro do item (crítico).',
    criterios: [
      'Com algum crítico em falta, o valor sai em vermelho.',
      'Nunca passa de Itens a comprar.',
    ],
    situacao: 'rascunho', responsavel: 'Compras', revisadaEm: REVISAO,
  },
  {
    codigo: 'IND-COM-03', titulo: 'Já pedidos', papel: 'compras',
    quero: 'ver o que falta mas já está pedido', para: 'não comprar a mesma peça duas vezes',
    significa: 'Falta que um pedido aberto já cobre. Não comprar outra vez.',
    calcula: 'Conta os itens com Comprar igual a zero e Em pedido maior que zero. Pedido aberto é o aprovado ou emitido com item faltando chegar; rascunho não conta.',
    origem: 'Compras · necessidade líquida e pedidos (0052).',
    criterios: [
      'Aprovar um pedido move o item de Itens a comprar para Já pedidos.',
      'Pedido em rascunho não muda este número.',
    ],
    situacao: 'rascunho', responsavel: 'Compras', revisadaEm: REVISAO,
  },
  {
    codigo: 'IND-COM-04', titulo: 'Comprometido', papel: 'controladoria',
    quero: 'ver quanto já está comprometido em compra', para: 'acompanhar o gasto antes da nota chegar',
    significa: 'Valor estimado dos pedidos aprovados e emitidos.',
    calcula: 'Soma do valor estimado (quantidade × preço do pedido) dos pedidos aprovados e emitidos, em R$.',
    origem: 'Compras · pedidos e itens do pedido (0052).',
    criterios: [
      'Pedido em rascunho ou cancelado não entra.',
      'Enquanto os pedidos carregam, o card mostra esqueleto, não R$ 0,00.',
    ],
    situacao: 'rascunho', responsavel: 'Compras', revisadaEm: REVISAO,
  },
  {
    codigo: 'COL-COM-05', titulo: 'Comprar', papel: 'compras',
    quero: 'ver quanto falta comprar de cada item', para: 'não pedir de novo o que já está a caminho',
    significa: 'Necessidade líquida: o que as preventivas e o estoque mínimo pedem e nenhum pedido aberto cobre.',
    calcula: 'Demanda − Disponível − Em pedido, nunca negativo. A demanda é a maior entre a da preventiva e a do mínimo, nunca a soma.',
    origem: 'Manutenção · planos, Estoque · saldos, Compras · pedidos. Recalcula a cada abertura.',
    criterios: [
      'Pedido aprovado desconta na hora da coluna Comprar.',
      'Item sem demanda não aparece na lista.',
      'Item crítico com falta sai em vermelho.',
    ],
    situacao: 'rascunho', responsavel: 'Compras', revisadaEm: REVISAO,
  },
  {
    codigo: 'CMP-COM-06', titulo: 'Custo unitário', papel: 'almoxarifado',
    quero: 'informar quanto a peça custou de fato no recebimento', para: 'o custo da máquina sair do preço pago',
    significa: 'O custo do recebimento. É ele que chega ao custo por máquina, não o preço estimado do pedido.',
    calcula: 'Grava o custo na entrada do estoque gerada pelo recebimento. O custo da saída para a máquina é a média das entradas do item até a data.',
    origem: 'Compras · recebimento (POST /compras/itens/:id/recebimentos), que grava a entrada em estoq.movimento.',
    criterios: [
      'O campo é opcional; item sem custo em nenhuma entrada conta como lançamento sem preço no custo.',
      'Receber a mais do que foi pedido é recusado.',
    ],
    situacao: 'rascunho', responsavel: 'Compras', revisadaEm: REVISAO,
  },
  {
    codigo: 'BTN-COM-07', titulo: 'Aprovar pedido', papel: 'compras',
    quero: 'aprovar o pedido dentro da minha alçada', para: 'a compra sair sem passar por cima do limite',
    significa: 'Aprova o pedido; acima da alçada de compra, o botão vira "Enviar para aprovação".',
    calcula: 'O servidor confere pedido.aprovar e a alçada de compra (0079): valor do pedido = soma de quantidade × preço; item sem preço só passa por alçada sem teto. Empresa sem alçada de compra cadastrada aprova só pela permissão. Pedido sem item não se aprova.',
    origem: 'Compras · pedidos (POST /compras/pedidos/:id/aprovacao) e a alçada de compra do papel (org.alcada).',
    criterios: [
      'A tela mostra a alçada de quem está logado antes do botão.',
      'Acima da alçada, "Enviar para aprovação" leva o pedido a Aguardando aprovação e o sino avisa quem pode aprovar.',
      '"Pedir ajuste" devolve ao rascunho e avisa quem enviou.',
      'No app o botão traz o valor: "Aprovar R$ …".',
    ],
    situacao: 'em_revisao', responsavel: 'Compras', revisadaEm: REVISAO,
  },

  /* ------------------------------------------------------------- CST · Custos (p.58) */
  {
    codigo: 'NUM-CST-01', titulo: 'Custo direto', papel: 'controladoria',
    quero: 'ver o custo direto da frota no período', para: 'saber quanto as máquinas gastaram sem esperar o fechamento',
    significa: 'Combustível, peças, lubrificante e terceiros apropriados à máquina no período.',
    calcula: 'Combustível interno (litros × custo do litro pelo critério da empresa) + nota do posto + saídas do estoque menos devoluções, ao custo médio das entradas + lubrificante sem depósito + serviços de terceiros das O.S. Mão de obra entra em horas, não em R$.',
    origem: 'Custos · GET /custos/equipamentos, lendo Combustível, Estoque e Ordens de serviço. Recalcula a cada abertura.',
    criterios: [
      'O contexto do card diz "parcial" e quantos lançamentos ficaram sem preço.',
      'O card é a soma da coluna Total direto da tabela.',
      'A mesma peça não conta duas vezes: o lubrificante com depósito entra só pelo estoque.',
    ],
    situacao: 'rascunho', responsavel: 'Controladoria', revisadaEm: REVISAO,
  },
  {
    codigo: 'NUM-CST-02', titulo: 'Custo/h', papel: 'controladoria',
    quero: 'ver quanto custa cada hora de trabalho da máquina', para: 'comparar máquinas e preço de contrato pela mesma régua',
    significa: 'Custo direto dividido pelas horas produtivas apontadas no mesmo período.',
    calcula: 'Total direto ÷ horas produtivas apontadas no período, em R$/h. A hora de motor aparece ao lado como contexto. Sem hora produtiva, mostra —.',
    origem: 'Custos · custo direto; Operação · apontamentos (horas de produção). Pergunta 13 do placar, decisão 50.',
    criterios: [
      'A nota do período diz o denominador por extenso.',
      'Máquina sem hora apontada mostra — e não R$ 0,00.',
      'A coluna Hora produtiva traz a hora de motor embaixo.',
    ],
    situacao: 'rascunho', responsavel: 'Controladoria', revisadaEm: REVISAO,
  },
  {
    codigo: 'COL-CST-03', titulo: 'Combustível', papel: 'controladoria',
    quero: 'ver quanto cada máquina gastou de combustível', para: 'achar a que consome fora do esperado',
    significa: 'Valor dos abastecimentos lançados para a máquina no período.',
    calcula: 'Abastecimento interno: litros × custo do litro pelo critério da empresa (médio ponderado, PEPS ou última compra). Externo: o valor da nota do posto.',
    origem: 'Combustível · abastecimentos e livro do tanque.',
    criterios: [
      'O card de Combustível diz o critério de custeio em uso.',
      'Abastecimento sem preço conhecido não entra no valor e conta em "sem preço".',
    ],
    situacao: 'rascunho', responsavel: 'Controladoria', revisadaEm: REVISAO,
  },
  {
    codigo: 'COL-CST-04', titulo: 'Terceiros', papel: 'controladoria',
    quero: 'ver o gasto com serviço de fora em cada máquina', para: 'decidir o que vale trazer para a oficina',
    significa: 'Serviços de terceiros das O.S. da máquina, pelo valor lançado.',
    calcula: 'Soma do valor dos serviços externos das O.S. da máquina lançados no período, em R$.',
    origem: 'Ordens de serviço · serviços externos (oficina.servico_externo).',
    criterios: [
      'Serviço sem valor não entra na soma e conta em "sem preço".',
      'Abaixo de 1280 px a coluna sai da tabela e o valor segue no card Terceiros.',
    ],
    situacao: 'rascunho', responsavel: 'Controladoria', revisadaEm: REVISAO,
  },
  {
    codigo: 'NUM-CST-05', titulo: 'Margem', papel: 'controladoria',
    quero: 'ver a margem do período', para: 'saber se o contrato paga o custo total',
    significa: 'Receita medida menos o custo total: direto, depreciação e custo indireto rateado (0096). "Margem parcial" enquanto algo ficar fora do mês.',
    calcula: '(Receita − custo total) ÷ receita, no mês da competência. A máquina de vários contratos se divide pelas horas reconhecidas (ou apontadas); a sem alocação ou sem hora fica de fora, à vista.',
    origem: 'Receita · medições aprovadas; Custos · custo total (gestor/resultado.ts, custos/margem.ts).',
    criterios: [
      'Sem medição aprovada, mostra — e diz "sem medição aprovada".',
      'Margem negativa sai em vermelho.',
      'Nada se chama lucro.',
    ],
    situacao: 'em_revisao', responsavel: 'Controladoria', revisadaEm: REVISAO,
  },

  /* ------------------------------------------------------------ REC · Receita (p.58) */
  {
    codigo: 'BTN-REC-01', titulo: 'Montar medição', papel: 'controladoria',
    quero: 'montar a medição do mês de um contrato', para: 'a cobrança sair das horas reconhecidas e da regra vigente',
    significa: 'Junta as horas reconhecidas do mês com o valor da regra vigente do contrato.',
    calcula: 'Cria a medição aberta e uma linha por máquina alocada ao contrato no mês, com as horas reconhecidas e uma cópia da regra vigente (a da máquina vence a geral). Valor = horas na franquia × valor-hora + excedente × valor do excedente. Exige medicao.gravar.',
    origem: 'Receita · POST /receita/medicoes; Equipamentos · alocação; Operação · horas reconhecidas.',
    criterios: [
      'A medição nasce Aberta, e montar não é aprovar.',
      'Máquina alocada sem hora reconhecida entra com 0 h.',
      'A competência é o primeiro dia do mês.',
    ],
    situacao: 'rascunho', responsavel: 'Controladoria', revisadaEm: REVISAO,
  },
  {
    codigo: 'SEL-REC-02', titulo: 'Situação', papel: 'controladoria',
    quero: 'ver em que pé está cada medição', para: 'saber o que falta aprovar e o que já é receita',
    significa: 'Aberta, Em conferência, Aprovada ou Cancelada. Emitida e recebida não são situação: ficam no documento da medição.',
    calcula: 'A situação gravada na medição. Só Aprovada conta como receita; o documento e o recebimento aparecem ao lado do contrato.',
    origem: 'Receita · medições (rec.medicao, 0051).',
    criterios: [
      'A situação aparece escrita, nunca só a cor.',
      'O rodapé da coluna Valor da medição soma só as aprovadas.',
    ],
    situacao: 'rascunho', responsavel: 'Controladoria', revisadaEm: REVISAO,
  },
  {
    codigo: 'NUM-REC-03', titulo: 'Horas reconhecidas', papel: 'controladoria',
    quero: 'ver as horas que o cliente reconheceu', para: 'cobrar só o que foi aceito',
    significa: 'Horas que o cliente aceitou depois da conciliação.',
    calcula: 'Soma, no mês, das horas reconhecidas de cada máquina da medição, em h.',
    origem: 'Operação · conciliação de horas (oper.hora_reconhecida, 0037), copiada na medição ao montar.',
    criterios: [
      'É a hora reconhecida, não a apontada.',
      'Reprocessar a conciliação depois de montar não muda a medição já montada.',
    ],
    situacao: 'rascunho', responsavel: 'Controladoria', revisadaEm: REVISAO,
  },
  {
    codigo: 'BTN-REC-04', titulo: 'Emitir documento', papel: 'controladoria',
    quero: 'registrar o documento de cobrança da medição', para: 'saber o que já foi faturado',
    significa: 'Registra o documento de cobrança da medição aprovada, com número e data. O sistema não gera a nota.',
    calcula: 'Grava o documento com número e data de emissão, apontando para a medição. O documento não tem valor próprio: o valor é o da medição. Exige documento.emitir.',
    origem: 'Receita · POST /receita/medicoes/:id/documentos (rec.documento).',
    criterios: [
      'Medição que não está Aprovada não emite, e o menu diz por quê.',
      'Emitir não muda a receita do mês.',
    ],
    situacao: 'rascunho', responsavel: 'Controladoria', revisadaEm: REVISAO,
  },
  {
    codigo: 'BTN-REC-05', titulo: 'Registrar recebimento', papel: 'controladoria',
    quero: 'marcar quanto entrou e quando', para: 'ver o atraso e a diferença do que foi cobrado',
    significa: 'Marca o valor recebido e a data no documento. A situação da medição não muda.',
    calcula: 'Grava data e valor recebido no documento emitido. Recebido a menos aparece na diferença, sem virar receita nova. Exige documento.receber.',
    origem: 'Receita · POST /receita/documentos/:id/recebimento.',
    criterios: [
      'Só a medição com documento emitido recebe.',
      'Documento já recebido ou cancelado não recebe de novo.',
      'O valor da medição aparece na ajuda do campo Valor recebido.',
    ],
    situacao: 'rascunho', responsavel: 'Controladoria', revisadaEm: REVISAO,
  },

  /* ---------------------------------------------------------- CAD · Cadastros (p.59) */
  {
    codigo: 'FLT-CAD-01', titulo: 'Cadastro', papel: 'administrador',
    quero: 'escolher qual cadastro da estrutura listar', para: 'achar a filial, o cliente ou a obra sem trocar de tela',
    significa: 'Escolhe o que listar da estrutura: filiais, clientes, fornecedores, centros de custo, obras e locais, contratos.',
    calcula: 'Troca a lista, as colunas e o formulário pelo cadastro escolhido; trocar fecha o formulário aberto.',
    origem: 'Cadastros · estrutura (org.filial, org.cliente, org.fornecedor, org.centro_custo, org.obra, org.contrato).',
    criterios: [
      'São seis opções, e Fornecedores está entre elas.',
      'A contagem acima da lista diz o cadastro escolhido.',
    ],
    situacao: 'rascunho', responsavel: 'Administrador', revisadaEm: REVISAO,
  },
  {
    codigo: 'COL-CAD-02', titulo: 'Centro de custo', papel: 'controladoria',
    quero: 'ver o centro de custo de cada obra', para: 'o custo cair no lugar certo',
    significa: 'Onde o custo é apropriado. A obra traz um centro padrão, e a alocação da máquina pode apontar outro.',
    calcula: 'O centro de custo cadastrado na obra. Na alocação o centro é opcional: sem ele, a alocação fica sem centro.',
    origem: 'Cadastros · obras (org.obra.centro_custo_id); Equipamentos · alocação (0006).',
    criterios: [
      'Obra sem centro mostra "Sem centro de custo".',
      'Abaixo de 1280 px a coluna sai da lista de obras e fica nos dados-chave do painel.',
    ],
    situacao: 'rascunho', responsavel: 'Controladoria', revisadaEm: REVISAO,
  },
  {
    codigo: 'COL-CAD-03', titulo: 'Permissões', papel: 'administrador',
    quero: 'ver quantas permissões cada papel tem', para: 'conferir o que o papel libera antes de concedê-lo',
    significa: 'O que o papel pode ver e fazer, módulo por módulo. Na lista, a contagem; no painel do papel, cada uma.',
    calcula: 'Conta as permissões ligadas ao papel. O servidor confere a permissão em cada pedido.',
    origem: 'Cadastros · governança (papéis e permissões, 0005).',
    criterios: [
      'Conceder uma permissão no painel soma 1 na coluna.',
      'Sem a permissão, a ação é recusada dizendo qual pedir.',
    ],
    situacao: 'rascunho', responsavel: 'Administrador', revisadaEm: REVISAO,
  },
  {
    codigo: 'NUM-CAD-04', titulo: 'Limite', papel: 'diretoria',
    quero: 'definir até quanto cada papel aprova', para: 'o gasto grande passar por quem responde por ele',
    significa: 'Até quanto o papel aprova sem passar para o nível acima. Em branco é sem teto.',
    calcula: 'Uma linha por papel e assunto (compra, ajuste, ordem de serviço, liberação). Hoje travam a compra (0079) e o ajuste de tanque (0059).',
    origem: 'Cadastros · governança, alçadas de aprovação (org.alcada).',
    criterios: [
      'Limite em branco aparece como "Sem teto".',
      'Zero quer dizer que o papel não aprova valor nenhum.',
      'O valor sai em R$, alinhado à direita.',
    ],
    situacao: 'rascunho', responsavel: 'Diretoria', revisadaEm: REVISAO,
  },
  {
    codigo: 'ABA-CAD-05', titulo: 'Histórico', papel: 'controladoria',
    quero: 'ver quem mudou o cadastro, quando e por quê', para: 'explicar um dado que mudou sem perguntar a ninguém',
    significa: 'A trilha de alterações de um cadastro, do mais recente para o mais antigo.',
    calcula: 'Lê a trilha de auditoria do registro, com autor, data e motivo, da mais recente para a mais antiga. Exige auditoria.ler.',
    origem: 'Cadastros · GET /cadastros/trilha, gravada por gatilho em cada alteração.',
    criterios: [
      'Uma alteração aparece no topo da aba com o seu nome.',
      'Cadastro sem alteração mostra "Sem alterações registradas".',
    ],
    situacao: 'rascunho', responsavel: 'Administrador', revisadaEm: REVISAO,
  },

  /* ------------------------------------------------- BIB · Biblioteca técnica (p.59) */
  {
    codigo: 'BTN-BIB-01', titulo: 'Cadastrar documento', papel: 'planejador de manutenção',
    quero: 'cadastrar o manual na biblioteca', para: 'a resposta técnica citar a fonte certa',
    significa: 'Cadastra o documento e envia o arquivo. A ligação aos equipamentos é feita depois, na aba A que se aplica.',
    calcula: 'Grava título, tipo, origem, revisão e páginas, e recebe o PDF ou a imagem de até 100 MB, com o tipo conferido pelo conteúdo. Exige documento_tecnico.gerir.',
    origem: 'Biblioteca técnica · POST /tecnico/documentos e envio do arquivo.',
    criterios: [
      'O documento aparece na lista e, sem ligação, "Alcança" diz "Nenhuma máquina".',
      'O arquivo não se troca depois de enviado.',
    ],
    situacao: 'rascunho', responsavel: 'Planejador de manutenção', revisadaEm: REVISAO,
  },
  {
    codigo: 'CMP-BIB-02', titulo: 'A que se aplica', papel: 'planejador de manutenção',
    quero: 'ligar o documento às máquinas a que ele vale', para: 'a IA não citar o manual de outro modelo',
    significa: 'Fabricantes, modelos, configurações ou máquinas cobertos. A IA só cita o documento para essas máquinas.',
    calcula: 'Cada ligação aponta um fabricante, um modelo, uma configuração ou um equipamento; a máquina alcançada é a que cai em alguma delas.',
    origem: 'Biblioteca técnica · aplicações (POST /tecnico/documentos/:id/aplicacoes).',
    criterios: [
      'O campo "Ligar a" oferece fabricante, modelo, configuração e um equipamento.',
      'Documento revogado não se liga a mais nada.',
      'A coluna Alcança conta as ligações.',
    ],
    situacao: 'rascunho', responsavel: 'Planejador de manutenção', revisadaEm: REVISAO,
  },
  {
    codigo: 'BTN-BIB-03', titulo: 'Revogar documento', papel: 'planejador de manutenção',
    quero: 'tirar de uso um documento errado ou vencido', para: 'a IA parar de citá-lo sem apagar o passado',
    significa: 'Tira o documento de uso sem apagá-lo. Respostas antigas continuam mostrando a fonte.',
    calcula: 'Pede o motivo, marca o documento como revogado e o tira das respostas na hora, sem reindexar. Exige documento_tecnico.revogar.',
    origem: 'Biblioteca técnica · POST /tecnico/documentos/:id/revogacao.',
    criterios: [
      'Revogar sem motivo é recusado.',
      'A pergunta nova sobre a máquina não cita mais o documento.',
      'A resposta antiga continua com a citação.',
    ],
    situacao: 'rascunho', responsavel: 'Planejador de manutenção', revisadaEm: REVISAO,
  },
  {
    codigo: 'NUM-BIB-04', titulo: 'Página citada', papel: 'oficina e mecânicos',
    quero: 'ver de que página saiu a resposta', para: 'abrir o manual e conferir antes de mexer na máquina',
    significa: 'A página exata de onde saiu a resposta técnica ou a tarefa do plano.',
    calcula: 'A página do trecho que o modelo citou, conferida contra os trechos que ele recebeu. Fato do histórico da máquina não tem página.',
    origem: 'Biblioteca técnica · trechos com página; IA · perguntas (tecnico.pergunta, citações guardadas).',
    criterios: [
      'A citação traz o título e "p." com o número.',
      'O toque na citação abre o manual naquela página.',
    ],
    situacao: 'rascunho', responsavel: 'Planejador de manutenção', revisadaEm: REVISAO,
  },
  {
    codigo: 'BTN-BIB-05', titulo: 'Pergunte aos manuais', papel: 'oficina e mecânicos',
    quero: 'perguntar aos manuais da máquina', para: 'decidir com a página certa na mão',
    significa: 'Abre o assistente, que responde citando documento e página, e o histórico da máquina.',
    calcula: 'Sem trecho que sustente, a resposta é "não sei", dizendo o que falta, e o motor nem é chamado. Documento restrito não vai ao motor. Exige ia.perguntar.',
    origem: 'Biblioteca técnica · documentos validados que alcançam a máquina; IA · POST /equipamentos/:id/perguntas.',
    criterios: [
      'Toda resposta cita a fonte.',
      'A resposta pede a nota: serviu ou não.',
      'Sem a permissão de perguntar, o botão não aparece.',
    ],
    situacao: 'em_revisao', responsavel: 'Planejador de manutenção', revisadaEm: REVISAO,
  },

  /* ------------------------------------------------------------- ACS · Acesso (p.60) */
  {
    codigo: 'BTN-ACS-01', titulo: 'Entrar', papel: 'operador',
    quero: 'entrar no sistema com e-mail e senha', para: 'chegar às telas do meu papel',
    significa: 'Abre a sessão com e-mail e senha. O erro não diz se o e-mail existe.',
    calcula: 'Confere e-mail e senha no servidor e grava a sessão em cookie, por 12 h. Senha errada e e-mail inexistente dão a mesma frase; depois de 5 tentativas no mesmo e-mail, a espera cresce.',
    origem: 'Acesso · POST /sessao (freio de tentativas da 0015).',
    criterios: [
      'Senha errada mostra "e-mail ou senha não conferem", igual para e-mail inexistente.',
      'Muitas tentativas dizem quanto esperar.',
      'Na mesa o botão se chama "Entrar no sistema"; no app, "Entrar".',
    ],
    situacao: 'rascunho', responsavel: 'Administrador', revisadaEm: REVISAO,
  },
  {
    codigo: 'TEL-ACS-02', titulo: 'Primeiro acesso', papel: 'operador',
    quero: 'escolher a minha senha pelo convite', para: 'começar a usar o sistema sem senha passada por alguém',
    significa: 'Aberta pelo convite. A pessoa escolhe a senha e a sessão começa.',
    calcula: 'Confere o código do convite, grava a senha e abre a sessão. O convite vale uma vez e por 72 horas; inválido, usado e vencido dão a mesma resposta.',
    origem: 'Acesso · POST /convite/aceite (0024).',
    criterios: [
      'As duas senhas diferentes são recusadas, dizendo o que fazer.',
      'Convite já usado pede um convite novo a quem administra.',
      'Para quem já tem acesso, a tela se chama Trocar senha e encerra as sessões abertas.',
    ],
    situacao: 'rascunho', responsavel: 'Administrador', revisadaEm: REVISAO,
  },
  {
    codigo: 'NUM-ACS-03', titulo: 'Escopo além do papel', papel: 'administrador',
    quero: 'ver até onde o papel da pessoa alcança', para: 'quem responde por uma filial ver só as máquinas dela',
    significa: 'A filial a que os papéis da pessoa se restringem. Papel com filial estreita o que ela vê; papel sem filial vale na empresa inteira. Obra e contrato ainda não restringem.',
    calcula: 'Se todos os papéis ativos da pessoa têm filial, ela vê só as máquinas dessas filiais e as que estão numa obra delas. Basta um papel sem filial para valer a empresa inteira. A conferência é no banco.',
    origem: 'Acesso · papéis da pessoa (org.usuario_papel.filial_id, 0081).',
    criterios: [
      'No app, Perfil · Alcance diz "Só na filial … e nas obras dela" ou "A empresa inteira".',
      'Conceder um papel com alcance de filial tira da lista a máquina de outra filial.',
    ],
    situacao: 'rascunho', responsavel: 'Administrador', revisadaEm: REVISAO,
  },

  /* ------------------------------------------- PLT · Administração da plataforma (p.60) */
  {
    codigo: 'BTN-PLT-01', titulo: 'Criar empresa', papel: 'administrador da plataforma',
    quero: 'criar a empresa de um cliente novo', para: 'ela começar com papéis e permissões prontos',
    significa: 'Cria a empresa na plataforma e convida o administrador dela.',
    calcula: 'Cria a empresa com o catálogo de permissões, os papéis da matriz aprovada e as causas de parada padrão, e gera o convite do administrador. O código do convite aparece uma vez; o banco guarda só o hash.',
    origem: 'Plataforma · POST /plataforma/empresas (0029, 0032).',
    criterios: [
      'Sem nome da empresa, nome e e-mail do administrador, o pedido é recusado.',
      'A empresa nova aparece na lista com o convite pendente.',
    ],
    situacao: 'rascunho', responsavel: 'Administrador da plataforma', revisadaEm: REVISAO,
  },
  {
    codigo: 'BTN-PLT-02', titulo: 'Convidar administrador', papel: 'administrador da plataforma',
    quero: 'convidar alguém para administrar a plataforma', para: 'a plataforma não depender de uma pessoa só',
    significa: 'Manda o convite para alguém administrar a plataforma.',
    calcula: 'Gera o código do convite com prazo de validade e o mostra uma vez; o ato fica na trilha da plataforma.',
    origem: 'Plataforma · POST /plataforma/administradores.',
    criterios: [
      'Sem nome e e-mail válido, o convite é recusado.',
      'O convidado aparece na lista de administradores.',
    ],
    situacao: 'rascunho', responsavel: 'Administrador da plataforma', revisadaEm: REVISAO,
  },
  {
    codigo: 'BTN-PLT-03', titulo: 'Desativar administrador', papel: 'administrador da plataforma',
    quero: 'tirar o acesso de um administrador', para: 'quem saiu não continuar entrando',
    significa: 'Tira o acesso e derruba a sessão na hora. Ninguém muda a própria situação.',
    calcula: 'Pede confirmação, marca o administrador como desativado e apaga as sessões dele. O banco recusa mudar a própria situação e recusa desativar o último administrador ativo.',
    origem: 'Plataforma · PUT /plataforma/administradores/:id/situacao (0032).',
    criterios: [
      'Na linha de quem está logado, o botão não aparece.',
      'Desativar o último administrador ativo é recusado.',
      'O desativado cai da sessão na hora.',
    ],
    situacao: 'rascunho', responsavel: 'Administrador da plataforma', revisadaEm: REVISAO,
  },
  {
    codigo: 'SEL-PLT-04', titulo: 'Situação', papel: 'administrador da plataforma',
    quero: 'ver quem pode entrar na plataforma', para: 'saber quem está ativo antes de desativar alguém',
    significa: 'Ativa ou desativada. A plataforma nunca fica sem administrador ativo.',
    calcula: 'A situação gravada do administrador.',
    origem: 'Plataforma · administradores (infra.administrador_plataforma).',
    criterios: [
      'A situação aparece escrita: Ativa ou Desativada.',
      'O desativado tem "Reativar administrador" na linha.',
    ],
    situacao: 'rascunho', responsavel: 'Administrador da plataforma', revisadaEm: REVISAO,
  },
  {
    codigo: 'CMP-PLT-05', titulo: 'Motor de IA', papel: 'administrador da plataforma',
    quero: 'escolher o provedor e os modelos de IA', para: 'todas as empresas usarem a mesma IA, conferida',
    significa: 'O modelo de IA que vale para todas as empresas. O teste etapa por etapa está ao lado; salvar não depende dele.',
    calcula: 'Protocolo, endereço, modelo para responder e, opcionais, modelo para ler arquivos e modelo de vetores. Salvar vale na hora neste servidor e em até 30 s nos outros, e fica na trilha com o motivo.',
    origem: 'Plataforma · PUT /plataforma/configuracoes/ia.',
    criterios: [
      'Salvar fica desligado quando nada mudou, dizendo por quê.',
      'IA em uso agora mostra o modelo salvo depois de salvar.',
    ],
    situacao: 'rascunho', responsavel: 'Administrador da plataforma', revisadaEm: REVISAO,
  },
  {
    codigo: 'COL-PLT-06', titulo: 'O que fazer', papel: 'administrador da plataforma',
    quero: 'saber o que corrigir quando o teste falha', para: 'acertar a configuração sem chamar o suporte',
    significa: 'No teste da configuração, o que corrigir quando uma etapa falha.',
    calcula: 'Três etapas: Responder, Ler arquivo e Vetores. Para cada uma, o resultado, o modelo, o tempo em ms e a correção que o servidor devolve.',
    origem: 'Plataforma · POST /plataforma/configuracoes/ia/teste, registrado na trilha.',
    criterios: [
      'Etapa que funcionou mostra — em O que fazer.',
      'A frase inteira quebra dentro da célula, sem corte.',
      'Sem a chave no servidor, o teste fica desligado, dizendo por quê.',
    ],
    situacao: 'rascunho', responsavel: 'Administrador da plataforma', revisadaEm: REVISAO,
  },
];
